import PropTypes from "prop-types";

const ProveedoresTitle = (props) => {
    const { hideDivider, children } = props;

    return (
        <div className="title-main">
            <div className={"title container " + (!hideDivider ? "border" : "")}>
                <h2>{children}</h2>
            </div>
            {!hideDivider && <hr className="divider" />}
        </div>
    );
};

ProveedoresTitle.propTypes = {
    children: PropTypes.any,
    hideDivider: PropTypes.any,
};

export default ProveedoresTitle;
